import { render } from "./page-1.vue?vue&type=template&id=286aa25c&scoped=true"
import script from "./page-1.vue?vue&type=script&lang=js"
export * from "./page-1.vue?vue&type=script&lang=js"

import "./page-1.vue?vue&type=style&index=0&id=286aa25c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286aa25c"]])

export default __exports__